document.addEventListener('DOMContentLoaded', function () {
  // Setup
  const sectionSelector = '.employees-display-container';
  const formSelector = '.employees-display-filters form';
  const formSearchInputSelector = 'input[name="search"]';
  const formSelectInputSelector = '.employees-display-filter-select select';
  const activeFiltersSelector = '.employees-display-active-filters';
  const resultsSelector = '.programs-results';
  const loadingSelector = '.employees-display-loading';
  const removeFilterClass = 'employees-display-remove-filter';

  // Start
  const section = document.querySelector(sectionSelector);
  const form = section?.querySelector(formSelector);
  const results = section?.querySelector(resultsSelector);
  const loading = section?.querySelector(loadingSelector);
  let debounceTimer;

  if (!section || !results) return;

  // Helper to serialize form data, removing empty values
  function serializeForm(form) {
    const data = new FormData(form);
    const params = new URLSearchParams();
    for (const [key, value] of data.entries()) {
      if (value !== null && value !== undefined && value !== '') {
        params.append(key, value);
      }
    }
    return params.toString();
  }

  // Push state to history and optionally load results
  function updateState(push = true) {
    const query = serializeForm(form).replace(/%2C/gi, ',');
    const url = window.location.pathname + (query ? '?' + query : '');
    if (push) {
      history.pushState({ query }, '', url);
    }
    buildButtons();
    loadResults(url);
  }
  
  // AJAX load function for a given URL
  function loadResults(url) {
    results.classList.add('hidden');
    loading?.classList.remove('hidden');

    fetch(url)
      .then(res => res.text()
      .then(html => ({ html, url: res.url })))
      .then(({ html, url }) => {
        history.replaceState({}, '', url);

        // Create a temporary DOM to extract the new results
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const newResults = temp.querySelector(resultsSelector);
        if (newResults) {
          results.innerHTML = newResults.innerHTML;
        }

        // Scroll to the top of the section after loading
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
      .finally(() => {
        results.classList.remove('hidden');
        loading?.classList.add('hidden');
      });
  }

  // Debounced search
  const searchInput = form?.querySelector(formSearchInputSelector);
  if (searchInput && false) {
    searchInput.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => updateState(true), 350);
    });
  }

  // Change/select events for selects
  form?.querySelectorAll(formSelectInputSelector).forEach(select => {
    select.addEventListener('change', function(e) {
      const value = select.value;

      const input = select.parentElement.querySelector('input');
      const inputValue = input.value.split(',').filter((v) => v);
      inputValue.push(value);
      input.value = inputValue.join(',');

      select.value = '';

      updateState(true);
      select.blur();
    });
  });

  form?.querySelectorAll(formSelectInputSelector).forEach(select => {
    select.addEventListener('change', function(e) {
      const value = select.value;

      const input = select.parentElement.querySelector('input');
      const inputValue = input.value.split(',').filter((v) => v);
      inputValue.push(value);
      input.value = inputValue.join(',');

      select.value = '';

      updateState(true);
      select.blur();
    });
  });

  section?.querySelectorAll('select[data-per-page]').forEach(select => {
    select.addEventListener('change', function(e) {
      if(form){
        form.querySelector('[name="view"]').value = select.value;
        updateState(true);
      }
    });
  });

  // On form submit (e.g. pressing enter)
  form?.addEventListener('submit', function (e) {
    e.preventDefault();
    updateState(true);
  });

  // Handle removing filter
  function removeFilterFromButton(button){
    const field = button.dataset.field;
    const value = button.dataset.value;

    const input = form.querySelector('input[data-type="' + field + '"]');
    const inputValue = input.value.split(',').filter((v) => v && v !== value);
    input.value = inputValue.join(',');

    button.remove();
  }

  section?.querySelector(activeFiltersSelector).addEventListener('click', (e) => {
    const button = e.target.closest('button');

    if(!button) return;

    e.preventDefault();

    if(button.dataset.view){
      if(button.dataset.view == 'grid'){
        section.classList.add('view-grid');
        section.classList.remove('view-list');
      }else{
        section.classList.add('view-list');
        section.classList.remove('view-grid');
      }
    }else{
      if(button.dataset.clearAll){
        section.querySelectorAll(activeFiltersSelector + ' button[data-field]').forEach((element) => {
          removeFilterFromButton(element);
        });
      }else if(button.dataset.field){
        removeFilterFromButton(button);
      }

      updateState(true);
    }
  });

  // Delegate click event for pagination links
  section?.addEventListener('click', function (e) {
    const target = e.target.closest('.pagination a');
    if (target) {
      e.preventDefault();
      const url = target.getAttribute('href');
      if (url) {
        history.pushState({}, '', url);
        loadResults(url);
      }
    }
  });

  // Handle browser navigation (back/forward)
  window.addEventListener('popstate', function () {
    buildButtons();
    loadResults(window.location.href);
    loadFiltersFromUrl(window.location.href);
  });

  // Build the filter buttons
  function buildButtons() {
    const selects = form?.querySelectorAll(formSelectInputSelector);
    const activeFilters = section.querySelector(activeFiltersSelector);
    activeFilters.querySelectorAll('button[data-field]').forEach((btn) => btn.remove());

    selects.forEach((select) => {
      select.querySelectorAll('option').forEach((o) => o.disabled = false);
      select.querySelectorAll('option[value=""]').forEach((o) => o.disabled = true);

      const field = select.dataset.type;
      const input = select.parentElement.querySelector('input');
      const inputValue = input.value.split(',').filter((v) => v);

      inputValue.forEach((value) => {
        select.querySelector('option[value="' + value + '"]').disabled = true;

        const label = select.querySelector('option[value="' + value + '"]').innerText;
        const button = '<button type="button" data-field="' + field + '" data-value="' + value + '"><span>' + label + '</span><div class="' + removeFilterClass + '"></div></button>';
        activeFilters.insertAdjacentHTML('beforeend', button);
      });

      select.disabled = Array.from(select.options).every(option => option.disabled);
    });
  }

  // Update the fields from the parameters in the url
  function loadFiltersFromUrl(url) {
    const urlObj = new URL(url, window.location.origin);
    const params = new URLSearchParams(urlObj.search);

    form.querySelectorAll('input[data-type]').forEach(input => {
      const type = input.dataset.type;
      const paramValue = params.get(type.replace(/-/g, '_')) || params.get(type) || '';
      input.value = paramValue;
    });

    buildButtons();
  }
});